import InStockL2Heading from '@/components/Stocks/Pages/InStockDetailPageV2/InL2Heading'
import { ManagementType } from '@/components/Stocks/Widgets/types'
import Text from '@/stories/components/Common/NewText'

type ManagementTeamWidgetProps = {
  data: ManagementType[]
  short_name?: string
}

const ManagementTeam = ({
  data = [],
  short_name,
}: ManagementTeamWidgetProps) => {
  if (!data.length) return null
  return (
    <div>
      {short_name && (
        <InStockL2Heading
          heading={`Management Team and Key People in ${short_name}`}
        />
      )}
      <div className="flex flex-wrap gap-4">
        {data.map(({ name = '', title = '' }, index) => (
          <div
            key={index}
            className="flex-[0_0_calc(50%-8px)] border-b-[0.5px] py-4"
          >
            {!!name && (
              <Text appearance="subtitle1" addClassName="!text-base">
                {name}
              </Text>
            )}
            {!!title && (
              <Text appearance="body1" addClassName="text-brand-grey-base">
                {title}
              </Text>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default ManagementTeam
